import { BigNumber, ethers, FixedNumber } from 'ethers';
import { dappStore } from '.';

// const updatelvUSDToArchRatio = (contracts, setCallback) => {
//   return contracts.parameterStore.getArchToLevRatio().then((value) => {
//     setCallback(returnNumber(value), value);
//   });
// };
// const updateERC20Balance = (token, address, setCallback) => {
//   return token.balanceOf(address).then((userTokenBalance) => {
//     setCallback(returnNumber(userTokenBalance), userTokenBalance);
//   });
// };
// Todo: cycles type
export const setDebtAmount = async (principal: number, cycles: any, setCallback: any) => {
  try {
    const contracts = dappStore.getState().contracts;
    const principalIn18 = get18DecimalNumber(principal);
    const debtAmountBaseOnPrincipalPromise = contracts.parameterStore.getAllowedLeverageForPosition(
      principalIn18,
      cycles,
    );
    debtAmountBaseOnPrincipalPromise.then((allowedLev: BigNumber) => {
      setCallback(returnNumber(allowedLev), allowedLev);
    });
  } catch (err) {
    console.log('setDebtAmount err: ', err);
  }
};

// Todo: callback type
export const setArchNeededForPosition = async (leverageAmount: number, setCallback: any) => {
  const contracts = dappStore.getState().contracts;
  const leverageIn18 = get18DecimalNumber(leverageAmount);
  contracts.parameterStore.calculateArchNeededForLeverage(leverageIn18).then((archNeeded: BigNumber) => {
    setCallback(returnNumber(archNeeded), archNeeded);
  });
};

export let naturalNumber = true;
const returnNumber = (bigNum: BigNumber) => {
  if (naturalNumber) {
    const fullNumner = ethers.utils.formatEther(bigNum);
    return parseFloat(fullNumner);
  } else {
    return bigNum;
  }
};
const get18DecimalNumber = (bigNum: number) => {
  return ethers.utils.parseUnits(bigNum.toString());
};
